import * as React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles, Theme } from '@material-ui/core';

type BtnProps = {
  fullWidth?: boolean;
  classname?: string;
  onClick?(e: React.MouseEvent): void;
  type?: 'submit' | 'button' | 'reset';
  testId?: string;
  component?: React.ElementType;
  to?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    borderRadius: '40px',
    fontWeight: 400,
    fontSize: '1.3rem',
    letterSpacing: '0px',
    [theme.breakpoints.down('xs')]: {
      padding: '4px 16px',
      fontSize: '1.2rem'
    }
  }
}));

const CustomButton: React.FC<BtnProps> = ({ children, onClick, type = 'button', testId, classname, fullWidth, component, to }) => {
  const cl = useStyles();

  return (
    <Button
      component={component}
      className={`${cl.button} ${classname}`}
      fullWidth={fullWidth}
      disableElevation
      to={to}
      type={type}
      variant="contained"
      onClick={onClick}
      color="primary"
      data-testid={testId}
    >
      {children}
    </Button>
  )
};

export default CustomButton;
